

export default{
  "import_results_title": "Detalles de Transacción",
  "import_show_data": "Mostrar Datos",
  "import_no_details_available": "No hay detalles de transacción disponibles",
  "import_data_details": "Detalles de Datos",
  "import_data_message": "Mensaje",
  "refresh": "Actualizar",
  "close": "Cerrar",
  "import_status": "Estado",
  "import_status_processed": "Procesado",
  "import_status_failure": "Fallido",
  "import_status_pending": "Pendiente",
  "import_status_unknown": "Desconocido",
  // Messages for the details modal
  "import_company_id": "ID de Empresa",
  "import_unit_tags": "Etiquetas",
  
  "import_tag__id": "ID de Etiqueta",
  "import_tag__label": "Nombre de Etiqueta",
  "import_tag__color": "Color", 
  "import_tag__parentlabel": "Etiqueta Padre",
  
  "import_unit__esn": "ESN",
  "import_unit__id": "ID de Unidad",
  "import_unit__label": "Nombre de Unidad",
  "import_unit__driver": "Conductor",
  "import_unit__engine_hours": "Horas de Motor",
  "import_unit__default_driver": "Conductor Predeterminado",
  "import_unit__vin": "VIN",
  "import_unit__make": "Marca",
  "import_unit__model": "Modelo",
  "import_unit__year": "Año",
  "import_unit__odometer": "Odómetro",
  "import_unit__inspection_device_type": "Tipo de Dispositivo de Inspección",
  "import_unit__power_unit_number": "Número de Unidad de Potencia",
  "import_unit__inspection_tag_id": "ID de Etiqueta de Inspección",
  "import_unit__maintenance_company": "Compañía de Mantenimiento",
  "import_unit__registration_country": "País de Registro",
  "import_unit__registration_state": "Estado de Registro",
  "import_unit__registration_expiration": "Fecha de Expiración de Registro",
  "import_unit__engine_serial_number": "Número de Serie del Motor",
  "import_unit__license_plate": "Matrícula",
  "import_unit__asset_type": "Tipo de Activo",
  "import_unit__asset_subtype": "Subtipo de Activo",

  // Driver fields

  "import_driver__id": "ID",
  "import_driver__code": "Código de Conductor",
  "import_driver__name": "Nombre del Conductor",
  "import_driver__employee_number": "Número de Empleado",
  "import_driver__keyfob": "KeyFob",
  "import_driver__supervisor": "Supervisor",
  "import_driver__vehicle": "Vehículo",
  "import_driver__status": "Estado",
  "import_driver__timezone": "Zona Horaria",
  "import_driver__tags": "Etiquetas",
  "import_driver__email": "Correo Electrónico",
  "import_driver__phone": "Teléfono",
  "import_driver__ignition_driver_app": "App Ignition Driver",
  "import_driver__pin_number": "Número PIN",
  "import_driver__license_number": "Número de Licencia",
  "import_driver__license_expiration": "Fecha de Expiración de Licencia",
  "import_driver__registration_country": "País de Registro",
  "import_driver__registration_state": "Estado de Registro",
  "import_driver__hours_of_service_ruleset": "Regla de Horas de Servicio",
  "import_driver__hours_of_service_exempt": "Horas de servicio Exento",
  "import_driver__exempt_comment": "Comentario Exento",
  "import_driver__personal_conveyance": "Conducción personal",
  "import_driver__allowed_pc_distance": "Distancia permitida de PC",
  "import_driver__yard_moves": "Movimientos de patio",
  
  "import_asset__id": "ID de Activo",
  "import_asset__name": "Nombre de Activo",
  "import_asset__type": "Tipo de Activo",
  
  "import_user__id": "ID de Usuario", 
  "import_user__first_name": "Nombres",
  "import_user__last_name": "Apellidos",
  "import_user__username": "Nombre de Usuario",
  "import_asset__vin": "VIN",
  "import_asset__make": "Marca",
  "import_asset__model": "Modelo",
  "import_asset__year": "Año",
  "import_asset__status": "Estado",
  "import_asset__inspection_device_type": "Tipo de Dispositivo de Inspección",
  "import_asset__power_unit_number": "Número de Unidad de Potencia",
  "import_asset__inspection_tag_id": "ID de Etiqueta de Inspección",
  "import_asset__asset_type": "Tipo de Activo",
  "import_asset__asset_subtype": "Subtipo de Activo",
  "import_asset__external_id": "ID Externo",
  "import_asset__maintenance_company": "Compañía de Mantenimiento",
  "import_asset__registration_country": "País de Registro",
  "import_asset__registration_state": "Estado de Registro",
  "import_asset__registration_expiration": "Fecha de Expiración de Registro",
  "import_asset__engine_serial_number": "Número de Serie del Motor",
  "import_asset__chassis_serial_number": "Número de Serie del Chasis",
  "import_asset__license_plate": "Matrícula",

  "import_user__id": "ID de Usuario",
  "import_user__name": "Nombre de Usuario", 
  "import_user__email": "Correo Electrónico",
  // Unit import error messages
  "import_errormsg_U001": "ID vacío - fila omitida",
  "import_errormsg_U002": "Formato de ID inválido (debe ser un número entero positivo): {{unitId}}",
  "import_errormsg_U003": "La etiqueta no puede estar vacía - la etiqueta es obligatoria para las actualizaciones de unidad",
  "import_errormsg_U004": "Unidad con ID no encontrada en la cuenta: {{unitId}}",
  "import_errormsg_U005": "Acceso denegado: Sin permiso para modificar esta unidad: {{unitLabel}}",
  "import_errormsg_U006": "La etiqueta no existe: {{tagName}}",
  "import_errormsg_U007": "Acceso denegado: Sin permiso para asignar etiquetas: {{tagName}}",
  "import_errormsg_U008": "No se detectaron cambios para la unidad: {{unitLabel}}",
  "import_errormsg_U009": "Formato de IMEI inválido (debe tener 15 dígitos)",
  "import_errormsg_U010": "La etiqueta de la unidad es demasiado larga (máximo 47 caracteres): {{unitLabel}}",
  "import_errormsg_U011": "VIN demasiado largo (máximo 17 caracteres): {{unitVin}}",
  "import_errormsg_U012": "La marca es demasiado larga (máximo 30 caracteres): {{unitMake}}",
  "import_errormsg_U013": "Valor de horas de motor inválido (debe ser numérico): {{engineHours}}",
  "import_errormsg_U014": "Valor de odómetro inválido (debe ser numérico): {{odometer}}",
  "import_errormsg_U015": "Año de vehículo inválido (debe estar entre 1900 y el año actual + 1): {{vehicleYear}}",
  "import_errormsg_U016": "Conductor no encontrado en la cuenta: {{unitDriver}}",
  "import_errormsg_U017": "Error al buscar conductor: {{unitDriver}}",
  "import_errormsg_U018": "Error al actualizar unidad: {{unitLabel}}",
  "import_errormsg_U019": "Error de procesamiento para unidad: {{unitLabel}}",
  "import_errormsg_U020": "Tipo de dispositivo de inspección inválido para activo: {{unitInspectionDeviceType}}",
  "import_errormsg_U021": "Número de unidad de potencia demasiado largo (máximo 10 caracteres)",
  "import_errormsg_U022": "ID de etiqueta de inspección demasiado largo (máximo 9 caracteres)",
  "import_errormsg_U023": "Valor de horas de motor inválido (no puede ser negativo): {{engineHours}}",
  "import_errormsg_U024": "Valor de odómetro inválido (no puede ser negativo): {{odometer}}",
  "import_errormsg_U025": "Valor de horas de motor inválido (excede el máximo permitido): {{engineHours}}",
  "import_errormsg_U026": "Valor de odómetro inválido (excede el máximo permitido): {{odometer}}",
  "import_errormsg_U027": "Conductor predeterminado no encontrado en la cuenta: {{defaultDriver}}",
  "import_errormsg_U028": "Falló la búsqueda del conductor predeterminado para: {{defaultDriver}}",
  "import_errormsg_U029": "Compañía de mantenimiento inválida: {{unitMaintenanceCompany}}",
  "import_errormsg_U030": "Formato de país de registro inválido: {{unitRegisCountry}}",
  "import_errormsg_U031": "País de registro no encontrado en la base de datos: {{unitRegisCountry}}",
  "import_errormsg_U032": "Formato de estado de registro inválido: {{unitRegisState}}",
  "import_errormsg_U033": "Estado de registro no encontrado en la base de datos: {{unitRegisState}}",
  "import_errormsg_U034": "Formato de fecha de expiración de registro inválido: {{unitRegisExpDate}}",
  "import_errormsg_U035": "Año de expiración de registro inválido: {{unitRegisExpDate}}",
  "import_errormsg_U036": "El tipo de activo no puede estar vacío al actualizar una unidad",
  "import_errormsg_U037": "El subtipo de activo no puede estar vacío al actualizar una unidad",
  "import_errormsg_U038": "Tipo de activo no encontrado: {{unitAssetType}}",
  "import_errormsg_U039": "Subtipo de activo no encontrado: {{unitAssetSubtype}}",
  "import_errormsg_U040": "Error al resolver tipo/subtipo de activo",
  "import_errormsg_U041": "El número de serie del motor debe ser alfanumérico: {{unitEngineSerialNumber}}",
  "import_errormsg_U042": "Número de serie del motor demasiado largo (máximo 30 caracteres).",
  "import_errormsg_U043": "La matrícula debe ser alfanumérica: {{unitLicensePlate}}",
  "import_errormsg_U044": "La matrícula demasiado larga (máximo 20 caracteres): {{unitLicensePlate}}",
  "import_errormsg_U045": "El ID de la etiqueta de inspección debe ser numérico y positivo: {{unitInspectionTagId}}",
  "import_errormsg_U046": "El modelo del vehículo es demasiado largo (máximo 50 caracteres): {{unitModel}}",
  "import_errormsg_U047": "El ID de la etiqueta de inspección debe ser un número positivo mayor que cero: {{unitInspectionTagId}}",
  "import_errormsg_U048": "El número de serie del chasis debe ser alfanumérico: {{unitChassisSerialNumber}}",
  "import_errormsg_U049": "El número de serie del chasis es demasiado largo (máximo 30 caracteres): {{unitChassisSerialNumber}}",
  "import_errormsg_U050": "Estado inválido para Colombia: valor esperado \"CO-CO\", recibido: {{unitRegisState}}",
  "import_errormsg_U051": "Estado inválido para Perú: valor esperado \"PE-PE\", recibido: {{unitRegisState}}",
  "import_errormsg_U052": "Estado inválido para el país \"Ninguno\": valor esperado \"Ninguno\", recibido: {{unitRegisState}}",
  "import_errormsg_U053": "Se requiere estado para registros de Estados Unidos/Canada: {{unitRegisCountry}}",
  "import_errormsg_U054": "El estado no pertenece al país especificado: {{unitRegisState}}",
  "import_errormsg_U055": "Se requiere país de registro cuando se proporciona el estado de registro.",
  // Tag import error messages
  "import_errormsg_T001": "Campo requerido faltante: Etiqueta",
  "import_errormsg_T002": "La etiqueta es demasiado larga (máximo 100 caracteres): {{tagLabel}}",
  "import_errormsg_T003": "La etiqueta no puede estar vacía",
  "import_errormsg_T004": "Formato de ID inválido: El ID debe contener solo números: {{tagId}}",
  "import_errormsg_T005": "Etiqueta con ID no encontrada en la empresa: {{tagId}}",
  "import_errormsg_T006": "Acceso denegado: Sin permiso para modificar etiqueta: {{tagLabel}}",
  "import_errormsg_T007": "Etiqueta padre no encontrada: {{parentLabel}}",
  "import_errormsg_T008": "Operación no válida: La etiqueta no puede ser su propio padre: {{tagLabel}}",
  "import_errormsg_T009": "Acceso denegado: Sin permiso para etiqueta padre: {{parentLabel}}",
  "import_errormsg_T010": "La etiqueta ya existe (duplicada): {{tagLabel}}",
  "import_errormsg_T011": "No se detectaron cambios para etiqueta: {{tagLabel}}",
  "import_errormsg_T012": "Error de procesamiento para etiqueta: {{tagLabel}}",
  "import_errormsg_T013": "Error al crear etiqueta: {{tagLabel}}",
  "import_errormsg_T014": "Error al actualizar etiqueta: {{tagLabel}}",

    // Asset import error messages
  "import_errormsg_A001": "Campo requerido faltante: ID de Activo",
  "import_errormsg_A002": "Formato de ID inválido (debe ser un número entero positivo): {{assetId}}",
  "import_errormsg_A003": "La etiqueta del activo no puede estar vacía",
  "import_errormsg_A004": "Activo con ID no encontrado en la cuenta: {{assetId}}",
  "import_errormsg_A005": "Acceso denegado: Sin permiso para modificar activo: {{assetLabel}}",
  "import_errormsg_A006": "Etiqueta no encontrada en la cuenta: {{tagNameAsset}}",
  "import_errormsg_A007": "Acceso denegado: Sin permiso para asignar etiquetas: {{tagNameAsset}}",
  "import_errormsg_A008": "No se detectaron cambios para el activo: {{assetLabel}}",
  "import_errormsg_A010": "Error al crear activo: La etiqueta ya está en uso: {{assetLabel}}",
  "import_errormsg_A011": "Error al actualizar activo: La etiqueta ya está en uso: {{assetLabel}}",
  "import_errormsg_A013": "VIN demasiado largo (máximo 17 caracteres): {{assetVin}}",
  "import_errormsg_A014": "Marca demasiado larga (máximo 30 caracteres): {{assetMake}}",
  "import_errormsg_A015": "Modelo demasiado largo (máximo 50 caracteres): {{assetModel}}",
  "import_errormsg_A016": "Año inválido (debe estar entre 1980 y el año actual + 1): {{assetYear}}",
  "import_errormsg_A017": "Placa de matrícula demasiado larga (máximo 10 caracteres): {{licensePlate}}",
  "import_errormsg_A018": "Error de procesamiento para activo: {{assetLabel}}",
  "import_errormsg_A019": "Error al crear activo: {{assetLabel}}",
  "import_errormsg_A020": "Error al actualizar activo: {{assetLabel}}",
  "import_errormsg_A021": "Tipo de activo no encontrado: {{assetTypeName}}",
  "import_errormsg_A022": "Subtipo de activo no encontrado: {{assetSubtypeName}}",
  "import_errormsg_A023": "Error al resolver tipo/subtipo de activo: {{assetLabel}}",
  "import_errormsg_A024": "Error al crear activo: ID externo ya está en uso: {{assetExternalId}}",
  "import_errormsg_A025": "Error al actualizar activo: ID externo ya está en uso: {{assetExternalId}}",
  "import_errormsg_A026": "La etiqueta excede la longitud máxima de 50 caracteres",
  "import_errormsg_A027": "El ID externo excede la longitud máxima de 50 caracteres",
  "import_errormsg_A028": "El VIN debe ser alfanumérico: {{assetVin}}",
  "import_errormsg_A029": "El ID externo debe ser alfanumérico: {{assetExternalId}}",
  "import_errormsg_A030": "El tipo de activo no puede estar vacío al actualizar/crear un activo",
  "import_errormsg_A031": "El subtipo de activo no puede estar vacío al actualizar/crear un activo",
  "import_errormsg_A032": "Error al crear activo: VIN ya está en uso: {{assetVin}}",
  "import_errormsg_A033": "Error al actualizar activo: VIN ya está en uso: {{assetVin}}",
  "import_errormsg_A034": "Formato de ID de etiqueta de inspección no válido: El ID de etiqueta de inspección debe ser un número: {{inspectionTagId}}",
  "import_errormsg_A035": "Etiqueta de inspección demasiado larga (máximo 9 caracteres): {{inspectionTagId}}",
  "import_errormsg_A036": "Formato de ID de etiqueta de inspección no válido: El ID de etiqueta de inspección debe ser un número positivo mayor que cero: {{inspectionTagId}}",
  "import_errormsg_A037": "Compañía de mantenimiento no encontrada: {{assetMaintenanceCompany}}",
  "import_errormsg_A038": "Formato de país de registro no válido: {{assetRegisCountry}}",
  "import_errormsg_A039": "País de registro no encontrado en la base de datos: {{assetRegisCountry}}",
  "import_errormsg_A040": "Formato de estado de registro no válido: {{assetRegisState}}",
  "import_errormsg_A041": "Estado de registro no encontrado en la base de datos: {{assetRegisState}}",
  "import_errormsg_A042": "Formato de fecha de expiración de registro no válido: {{assetRegisExpiration}}",
  "import_errormsg_A043": "Año de expiración de registro inválido (debe estar entre 1980 y el año actual + 1): {{assetRegisExpiration}}",
  "import_errormsg_A044": "El número de serie del motor debe ser alfanumérico: {{assetEngSerialNumber}}",
  "import_errormsg_A045": "El número de serie del motor es demasiado largo (máximo 30 caracteres): {{assetEngSerialNumber}}",
  "import_errormsg_A046": "La matrícula debe ser alfanumérico: {{assetLicensePlate}}",
  "import_errormsg_A047": "La matrícula es demasiado larga (máximo 20 caracteres): {{assetLicensePlate}}",
  "import_errormsg_A048": "El número de unidad de potencia es demasiado largo (máximo 10 caracteres): {{assetPowerUnitNumber}}",
  "import_errormsg_A049": "Tipo de dispositivo de inspección no válido: {{assetInspectionDeviceType}}",
  "import_errormsg_A050": "El número de serie del chasis debe ser alfanumérico: {{assetChasSerialNumber}}",
  "import_errormsg_A051": "El número de serie del chasis es demasiado largo (máximo 30 caracteres): {{assetChasSerialNumber}}",
  "import_errormsg_A052": "Estado no válido para Colombia: valor esperado \"CO-CO\", recibido: {{assetRegisState}}",
  "import_errormsg_A053": "Estado no válido para Perú: valor esperado \"PE-PE\", recibido: {{assetRegisState}}",
  "import_errormsg_A054": "Estado no válido para el país \"None\": valor esperado \"None\", recibido: {{assetRegisState}}",
  "import_errormsg_A055": "Se requiere estado para registros de Estados Unidos/Canadá: {{assetRegisCountry}}",
  "import_errormsg_A056": "El estado no pertenece al país especificado: {{assetRegisState}}",
  "import_errormsg_A057": "Se requiere país de registro cuando se proporciona el estado de registro.",
  "import_errormsg_A058": "El estado del activo no es válido: {{assetStatus}}. Los valores permitidos son Activo o Inactivo.",
  "import_errormsg_A059": "Error al actualizar el activo: La matrícula ya está en uso: {{assetLicensePlate}}",
  "import_errormsg_A060": "Error al actualizar el activo: El ID de la etiqueta de inspección ya está en uso: {{inspectionTagId}}",
  "import_errormsg_A061": "Error al crear el activo: La matrícula ya está en uso: {{assetLicensePlate}}",
  "import_errormsg_A062": "Error al crear el activo: El ID de la etiqueta de inspección ya está en uso: {{inspectionTagId}}",

  // User import error messages
  "import_errormsg_US001": "Archivo CSV vacío: El archivo no contiene filas de datos. Por favor, agregue al menos una fila con información de usuario.",
  "import_errormsg_US002": "Error de formato CSV: La columna ID es requerida para actualizaciones de usuario.",
  "import_errormsg_US003": "No se encontraron filas de datos válidas: ID, Nombre, Apellido, Correo Electrónico, Nombre de Usuario, Rol, Etiquetas no pueden estar vacías en todas las filas.",
  "import_errormsg_US004": "El ID es requerido - solo se pueden actualizar usuarios existentes",
  "import_errormsg_US005": "Formato de ID inválido: ID debe ser un número entero positivo sin decimales",
  "import_errormsg_US006": "Usuario con ID {{userId}} no encontrado en la compañía",
  "import_errormsg_US007": "Rol no encontrado: {{userRole}}",
  "import_errormsg_US008": "Etiqueta {{userTag}} no encontrada",
  "import_errormsg_US009": "Acceso denegado: Sin permiso para asignar la etiqueta {{userTag}}",
  "import_errormsg_US010": "El nombre no puede estar vacío - el nombre es requerido para actualizar usuarios",
  "import_errormsg_US011": "El apellido no puede estar vacío - el apellido es requerido para actualizar usuarios",
  "import_errormsg_US012": "El correo electrónico no puede estar vacío - el correo es requerido para actualizar usuarios",
  "import_errormsg_US013": "Formato de correo electrónico inválido - el correo debe ser válido",
  "import_errormsg_US014": "El rol no puede estar vacío - el rol es requerido para actualizar usuarios",
  "import_errormsg_US015": "La etiqueta no puede estar vacía - la etiqueta es requerida para actualizar usuarios",
  "import_errormsg_US016": "Acceso denegado: Sin permiso para modificar este usuario",
  "import_errormsg_US017": "El nombre de usuario no puede estar vacío - el nombre de usuario es requerido para actualizar usuarios",
  "import_errormsg_US018": "Advertencia: El nombre de usuario es inmutable y no se puede cambiar mediante la importación de CSV",
  "import_errormsg_US019": "Advertencia: El correo electrónico es inmutable y no se puede cambiar mediante la importación de CSV",
  "import_errormsg_US020": "Formato de teléfono inválido: el teléfono debe contener solo dígitos",
  "import_errormsg_US021": "Teléfono demasiado corto: el teléfono debe tener al menos 10 dígitos",
  "import_errormsg_US022": "Teléfono demasiado largo: el teléfono debe tener como máximo 15 dígitos",
  "import_errormsg_US023": "Nombre demasiado largo: el nombre debe tener un máximo de 50 caracteres",
  "import_errormsg_US024": "Apellido demasiado largo: el apellido debe tener un máximo de 50 caracteres",
  "import_errormsg_US025": "Formato de fecha de expiración inválido: {{userExpiryDate}}",
  "import_errormsg_US026": "Año de expiración inválido (debe estar entre 1900 y el año actual + 1): {{userExpiryDate}}",

  // Códigos de error de importación de conductor
  "import_errormsg_D001": "Campo requerido faltante: Código",
  "import_errormsg_D002": "Campo requerido faltante: Nombre del Conductor",
  "import_errormsg_D003": "Campo requerido faltante: Número de Empleado",
  "import_errormsg_D004": "Campo requerido faltante: Número PIN",
  "import_errormsg_D005": "Campo requerido faltante: Número de Licencia",
  "import_errormsg_D006": "Campo requerido faltante: País de Registro",
  "import_errormsg_D007": "Campo requerido faltante: Estado de Registro",
  "import_errormsg_D008": "Campo requerido faltante: Zona Horaria",
  "import_errormsg_D009": "Campo requerido faltante: Etiquetas",
  "import_errormsg_D010": "Campo requerido faltante: KeyFob",
  "import_errormsg_D011": "Campo requerido faltante: Regla de Horas de Servicio (cuando Zonar ELD está habilitado)",
  "import_errormsg_D012": "Error de procesamiento (general)",
  "import_errormsg_D020": "Código excede la longitud máxima de 40 caracteres",
  "import_errormsg_D021": "Nombre del Conductor excede la longitud máxima de 100 caracteres",
  "import_errormsg_D022": "Número de Empleado excede la longitud máxima de 20 caracteres",
  "import_errormsg_D023": "Número PIN excede la longitud máxima de 4 caracteres",
  "import_errormsg_D024": "Número de Licencia excede la longitud máxima de 15 caracteres",
  "import_errormsg_D025": "KeyFob excede la longitud máxima de 20 caracteres",
  "import_errormsg_D026": "Correo electrónico excede la longitud máxima de 50 caracteres",
  "import_errormsg_D027": "Teléfono excede la longitud máxima de 15 caracteres",
  "import_errormsg_D030": "Formato de fecha de expiración de licencia inválido",
  "import_errormsg_D031": "Formato de correo electrónico inválido",
  "import_errormsg_D032": "El teléfono debe contener solo dígitos",
  "import_errormsg_D033": "La distancia PC permitida debe ser un número válido",
  "import_errormsg_D034": "El Número de Empleado debe ser un número entero (solo enteros, sin decimales)",
  "import_errormsg_D035": "La distancia PC permitida es obligatoria cuando la Conducción Personal está en Sí",
  "import_errormsg_D036": "La distancia PC permitida debe ser al menos 5 millas (8 km)",
  "import_errormsg_D037": "La distancia PC permitida no debe exceder 1608 km (1000 millas)",
  "import_errormsg_D038": "El Número PIN debe contener solo números",
  "import_errormsg_D039": "El KeyFob debe contener solo números",
  "import_errormsg_D041": "Número de Empleado ya existe (duplicado): {{employeeNumber}}",
  "import_errormsg_D042": "Nombre de usuario ya existe: {{driverUsername}}",
  "import_errormsg_D043": "Nombre del Conductor ya existe (duplicado): {{driverName}}",
  "import_errormsg_D044": "Sin permiso para etiquetas",
  "import_errormsg_D045": "Correo electrónico ya existe: {{driverEmail}}",
  "import_errormsg_D046": "Teléfono ya existe (duplicado): {{driverPhone}}",
  "import_errormsg_D047": "Código de Conductor ya existe (duplicado): {{driverCode}}",
  "import_errormsg_D048": "KeyFob ya existe (duplicado): {{keyFob}}",
  "import_errormsg_D049": "Número de Licencia ya existe (duplicado): {{licenseNumber}}",
  "import_errormsg_D050": "Error al crear conductor",
  "import_errormsg_D051": "Error al actualizar conductor",
  "import_errormsg_D052": "El Comentario Exento debe estar vacío cuando Horas de Servicio Exento es No",
  "import_errormsg_D053": "No se detectaron cambios",
  "import_errormsg_D054": "Zona horaria no encontrada: {{driverTimezone}}",
  "import_errormsg_D055": "Vehículo no encontrado: {{driverVehicle}}",
  "import_errormsg_D056": "Supervisor no encontrado: {{driverSupervisor}}",
  "import_errormsg_D057": "Regla de HOS no encontrada: {{driverHosRuleset}}",
  "import_errormsg_D058": "Código de país inválido: {{driverRegisCountry}}",
  "import_errormsg_D059": "Código de país no encontrado en la base de datos: {{driverRegisCountry}}",
  "import_errormsg_D060": "Código de estado inválido: {{driverRegisState}}",
  "import_errormsg_D061": "Código de estado no encontrado en la base de datos: {{driverRegisState}}",
  "import_errormsg_D062": "Formato de ID inválido: El ID debe ser un número positivo: {{driverId}}",
  "import_errormsg_D063": "Conductor con ID no encontrado en la compañía: {{driverId}}",
  "import_errormsg_D064": "Formato de correo electrónico inválido - puntos consecutivos no permitidos",
  "import_errormsg_D065": "Formato de correo electrónico inválido - estructura de dominio inválida",
  "import_errormsg_D066": "El Comentario Exento es obligatorio cuando Horas de Servicio Exento es Sí",
  "import_errormsg_D067": "Acceso denegado: Sin permiso para modificar conductor: {{driverName}}",
}